module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Fulvio Melia\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Fulvio Melia")]), _vm._v(" is professor of physics and astronomy at the University of Arizona. He is coeditor of "), _c('I', [_vm._v("The Central Parsecs of the Galaxy")]), _vm._v(" and scientific editor of "), _c('I', [_vm._v("The Astrophysical Journal")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15TehZy/tc-custom/9780226788449.jpg?1734282768991",
      "alt": "This image is the cover for the book Electrodynamics, Chicago Lectures in Physics"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Electrodynamics, Chicago Lectures in Physics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Practically all of modern physics deals with fields—functions of space (or spacetime) that give the value of a certain quantity, such as the temperature, in terms of its location within a prescribed volume. Electrodynamics is a comprehensive study of the field produced by (and interacting with) charged particles, which in practice means almost all matter."), _c('br'), _c('br'), _vm._v(" Fulvio Melia's "), _c('i', [_vm._v("Electrodynamics")]), _vm._v(" offers a concise, compact, yet complete treatment of this important branch of physics. Unlike most of the standard texts, "), _c('i', [_vm._v("Electrodynamics")]), _vm._v(" neither assumes familiarity with basic concepts nor ends before reaching advanced theoretical principles. Instead this book takes a continuous approach, leading the reader from fundamental physical principles through to a relativistic Lagrangian formalism that overlaps with the field theoretic techniques used in other branches of advanced physics. Avoiding unnecessary technical details and calculations, "), _c('i', [_vm._v("Electrodynamics")]), _vm._v(" will serve both as a useful supplemental text for graduate and advanced undergraduate students and as a helpful overview for physicists who specialize in other fields."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0